import { render, staticRenderFns } from "./TeamsGlobal.vue?vue&type=template&id=2144205d&scoped=true"
import script from "./TeamsGlobal.vue?vue&type=script&lang=js"
export * from "./TeamsGlobal.vue?vue&type=script&lang=js"
import style0 from "./TeamsGlobal.vue?vue&type=style&index=0&id=2144205d&prod&scoped=true&lang=css"
import style1 from "./TeamsGlobal.vue?vue&type=style&index=1&id=2144205d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144205d",
  null
  
)

export default component.exports